import { Header } from 'components/Header';
import { Footer } from 'components/Footer';
import { EditBikeForm } from 'components/Forms';

export function EditBike() {
  return (
    <>
      <Header />
      <EditBikeForm />
      <Footer />
    </>
  );
}
